import { render } from "./ItemNavigation.vue?vue&type=template&id=febcbbe4&scoped=true"
import script from "./ItemNavigation.vue?vue&type=script&lang=js"
export * from "./ItemNavigation.vue?vue&type=script&lang=js"

import "./ItemNavigation.vue?vue&type=style&index=0&id=febcbbe4&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-febcbbe4"]])

export default __exports__